import { $Elements, BrowserEvents, TransitionDurations } from './constants';
import {
	Swiper,
	Pagination,
	Navigation
} from 'swiper';

Swiper.use([Pagination]);

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Sections ----------
		$('.slider-text-image-section .section-carousel').each(function() {

			if(!this.swiper) {

				const swiper = new Swiper(this, {
					speed: TransitionDurations.default,
					loop: false,
					observer: true,
					slidesPerView: 1.15,
					breakpoints: {
						768: {
							slidesPerView: 2.2,
						},
						1280: {
							slidesPerView: 3.2,
						},
					},
					modules: [Pagination],
					pagination: {
						el: this.querySelector('.swiper-pagination'),
					},
					navigation: {
						nextEl: this.querySelector('.swiper-button-next'),
						prevEl: this.querySelector('.swiper-button-prev'),
					},
				});
			}
		});

		$('.wines-slider-section .section-carousel').each(function() {

			if(!this.swiper) {

				const swiper = new Swiper(this, {
					speed: TransitionDurations.default,
					loop: false,
					observer: true,
					slidesPerView: 'auto',
					pagination: {
						el: this.querySelector('.swiper-pagination'),
					},
					navigation: {
						nextEl: this.querySelector('.swiper-button-next'),
						prevEl: this.querySelector('.swiper-button-prev'),
					},
				});
			}
		});

		// ---------- Reviews Carousel ----------

		$('.reviews-section .section-carousel').each(function() {

			if(!this.swiper) {

				const swiper = new Swiper(this, {
					speed: TransitionDurations.default,
					slidesPerView: 1,
					spaceBetween: 20,
					breakpoints: {
						// when window width is <= 480px
						480: {
							slidesPerView: 1
						},
						// when window width is <= 768px
						768: {
							slidesPerView: 2
						},
						// when window width is <= 1024px
						1280: {
							slidesPerView: 3
						},
					},
					loop: false,
					observer: true,
					modules: [Navigation, Pagination],
					pagination: {
						el: this.querySelector('.swiper-pagination'),
						clickable: true
					},
					navigation: {
						nextEl: this.querySelector('.swiper-button-next'),
						prevEl: this.querySelector('.swiper-button-prev'),
					},
				});
			}
		});

		// ---------- Gallery Carousel ----------

		$('.carousel-section .section-carousel').each(function() {

			if(!this.swiper) {

				const swiper = new Swiper(this, {
					speed: TransitionDurations.default,
					loop: true,
					observer: true,
					slidesPerView: 1,
					pagination: {
						el: this.querySelector('.swiper-pagination'),
					},
					navigation: {
						nextEl: this.querySelector('.swiper-button-next'),
						prevEl: this.querySelector('.swiper-button-prev'),
					},
				});
			}
		});
	});

}(jQuery));
